export default {
  name: 'ParametersExtractor',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    parameters () {
      const matches = [...this.value.matchAll(/%\{(.+?)\}/g)]
      const variables = matches.map(([_, v]) => v)
      return [...new Set(variables)]
    }
  },
  render () {
    const result = this.$scopedSlots.default({
      parameters: this.parameters
    })
    // // console.log(`result`, result, `"${this.value}"`, this.parameters)
    return result
  }
}
